module.exports = __webpack_public_path__ + "static/media/programming-svgrepo-com (1).ee6eb270.svg";